import { useCallback } from 'react';

import type { BlockerFunction } from './blocker';
import { useBlocker } from './blocker';

export function usePrompt({
  when,
  message,
}: {
  when: boolean | BlockerFunction;
  message: string;
}): void {
  const shouldBlock = useCallback<BlockerFunction>(
    (args) => {
      const shouldBlock = typeof when === 'boolean' ? when : when(args);
      return shouldBlock && !window.confirm(message);
    },
    [when, message]
  );

  useBlocker(shouldBlock);
}
